import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ReportService } from '@sb-shared/services/report.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sb-report-list',
    templateUrl: './report-list.component.html',
    styleUrls: ['./report-list.component.scss'],
    standalone: false
})
export class ReportListComponent implements OnChanges {

  @Input() displayArea: number;
  @Output() onReportSelected = new EventEmitter<number>();
  @Output() onPrintClicked = new EventEmitter<void>();
  @Output() onRefreshClicked = new EventEmitter<void>();
  @Output() onFullScreenClicked = new EventEmitter<void>();

  reportList: any[] = [];
  selectedReport: number | '' = '';
  isLoading = 1;

  constructor(private reportService: ReportService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.displayArea?.currentValue) {
      this.isLoading = 1;
      this.reportService.getAvailableReports(changes.displayArea.currentValue)
        .pipe(take(1))
        .subscribe({
          next: (data: any[]) => {
            this.reportList = data || [];
            this.isLoading--;
          },
          error: () => {
            this.isLoading--;
          }
        });
    }
  }

  selectReport(): void {
    if (this.selectedReport !== '') {
      this.onReportSelected.emit(this.selectedReport as number);
    }
  }

  print(): void { this.onPrintClicked.emit(); }
  refresh(): void { this.onRefreshClicked.emit(); }
  fullScreen(): void { this.onFullScreenClicked.emit(); }
}
